import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared'
import { Col, Row } from 'react-awesome-styled-grid'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { MARKS } from '@contentful/rich-text-types'
import { BlockSection, RichTextContainer } from './sectionStyles'
import { CtaCard } from './CtaCard'
import type { ContentBlockLongTextType } from '../../../services/contentfulMarketingLandingPages'

const options = {
  renderNode: {
    [MARKS.CODE]: (node: any, children: any): React.ReactNode => {
      return <div dangerouslySetInnerHTML={{ __html: children }} />
    },
    'embedded-asset-block': (node: any): React.ReactNode => {
      return <img src={node.data.target.fields.file.url} />
    }
  }
}

export default function LongTextSection (props: {
  block: ContentBlockLongTextType,
  isFirst: boolean,
  isSingleContentBlock: boolean,
  isBannerSpaceVisible: boolean
}): React.ReactNode {
  const {
    id,
    backgroundColor,
    bodyText,
    textColor,
    bottomCardBackgroundImage,
    bottomCardBackgroundColor,
    bottomCardText,
    bottomCardCta,
    isFadeOutGradientVisible
  } = props.block

  const text = documentToReactComponents(bodyText!, options)

  const color =
    textColor === 'sand'
      ? colors.sand
      : textColor === 'midnightBlue'
        ? colors.midnightBlue
        : colors.white
  const linkColor =
    backgroundColor === 'Glow' ? colors.white : colors.tintOrange
  const isFadeOutVisible =
    isFadeOutGradientVisible &&
    (backgroundColor === 'Solid Sand' ||
      backgroundColor === 'Solid Midnight Blue')
  const gradientColor =
    backgroundColor === 'Solid Sand' ? colors.sand : colors.midnightBlue

  return (
    <BlockSection
      sectionId={id}
      backgroundColor={backgroundColor}
      isSingleContentBlock={props.isSingleContentBlock}
      isFirst={props.isFirst}
    >
      <Row align='center'>
        <Col
          xs={4}
          sm={8}
          md={6}
          lg={8}
          xl={8}
          align='center'
          offset={{ md: 1, lg: 2 }}
        >
          {!!bodyText && (
            <BodyTextWrapper color={color} linkColor={linkColor}>
              {text}
              {isFadeOutVisible && <Gradient color={gradientColor} />}
            </BodyTextWrapper>
          )}

          {!!bottomCardText && (
            <CtaCard
              bottomCardBackgroundColor={bottomCardBackgroundColor}
              bottomCardBackgroundImage={bottomCardBackgroundImage}
              bottomCardText={bottomCardText}
              bottomCardCta={bottomCardCta}
            />
          )}
        </Col>
      </Row>
    </BlockSection>
  )
}

const Gradient = styled.div<any>`
  bottom: 0;
  height: 110px;
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
  background: linear-gradient(
    178.24deg,
    rgba(38, 18, 47, 0) 1.49%,
    ${(props: any): string => props.color} 63.96%
  );
`

const BodyTextWrapper = styled(RichTextContainer)<any>`
  color: ${(props: any): string => props.color || colors.sand};
  max-width: 800px;
  position: relative;
`
